var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChlorit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.336,
    height: 53.336,
    viewBox: "0 0 53.336 53.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 53.336,
    height: 53.336,
    rx: 15,
    transform: "translate(0)",
    fill: "#fb0",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 32.883,
    height: 31.372,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_333",
    "data-name": "Groupe 333",
    transform: "translate(-15.446 -2746.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_10",
    "data-name": "Groupe de masques 10",
    transform: "translate(15.445 2746.634)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    width: 53.336,
    height: 53.336,
    transform: "translate(0 0)",
    fill: "#fb0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_255",
    "data-name": "Groupe 255",
    transform: "translate(24.907 2764.927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_254",
    "data-name": "Groupe 254",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_341",
    "data-name": "Trac\\xE9 341",
    d: "M345.615,7.592a.5.5,0,0,1-.495-.57l.951-6.595a.5.5,0,1,1,.988.142l-.951,6.595a.5.5,0,0,1-.493.428",
    transform: "translate(-325.982 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_342",
    "data-name": "Trac\\xE9 342",
    d: "M411.2,110.709a.5.5,0,0,1-.319-.883l4.259-3.536a.5.5,0,0,1,.638.768l-4.259,3.536a.5.5,0,0,1-.319.115",
    transform: "translate(-387.928 -100.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_343",
    "data-name": "Trac\\xE9 343",
    d: "M442.229,241.321a.5.5,0,0,1,0-1l6.457-.028a.5.5,0,1,1,0,1l-6.457.028Z",
    transform: "translate(-417.239 -226.972)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_344",
    "data-name": "Trac\\xE9 344",
    d: "M181.068,372.58a4.6,4.6,0,0,1-2.4-.717,6.789,6.789,0,0,1-2.7-7.854,4.232,4.232,0,0,1,2.461-2.538c2.427-.89,5.3.824,6.395,3.821a6.525,6.525,0,0,1,.141,4.262,4.269,4.269,0,0,1-2.55,2.787,3.9,3.9,0,0,1-1.348.239m-1.292-10.348a2.9,2.9,0,0,0-1,.177,3.25,3.25,0,0,0-1.873,1.96,5.795,5.795,0,0,0,2.29,6.644,3.11,3.11,0,0,0,4.827-1.77,5.526,5.526,0,0,0-.131-3.606,4.782,4.782,0,0,0-4.111-3.4",
    transform: "translate(-165.856 -341.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_345",
    "data-name": "Trac\\xE9 345",
    d: "M499.952,308.129a.5.5,0,0,1-.139-.978c1.628-.473,2.354-2.01,1.993-4.216-.345-2.11-1.972-3.607-3.626-3.336a.5.5,0,1,1-.161-.985c2.2-.359,4.338,1.506,4.773,4.16.445,2.72-.564,4.715-2.7,5.336a.5.5,0,0,1-.14.02",
    transform: "translate(-470.012 -282.016)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_346",
    "data-name": "Trac\\xE9 346",
    d: "M490.6,300.413a.5.5,0,0,1-.117-.984l.329-.08a.5.5,0,1,1,.235.97l-.329.08a.5.5,0,0,1-.118.014",
    transform: "translate(-462.931 -282.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_347",
    "data-name": "Trac\\xE9 347",
    d: "M233.37,305.145a.5.5,0,0,1-.114-.985l14.262-3.375a.5.5,0,1,1,.23.971l-14.262,3.375a.5.5,0,0,1-.115.014",
    transform: "translate(-219.96 -284.097)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_348",
    "data-name": "Trac\\xE9 348",
    d: "M531.52,451.327a.5.5,0,0,1-.166-.97l.443-.156a.5.5,0,1,1,.332.941l-.443.156a.5.5,0,0,1-.166.029",
    transform: "translate(-501.579 -425.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_349",
    "data-name": "Trac\\xE9 349",
    d: "M280.811,459.127a.5.5,0,0,1-.173-.967l13.9-5.142a.5.5,0,0,1,.346.936l-13.9,5.142a.5.5,0,0,1-.173.031",
    transform: "translate(-264.77 -427.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_350",
    "data-name": "Trac\\xE9 350",
    d: "M219.322,165.582a4.832,4.832,0,0,1-1.777-.354,6.813,6.813,0,0,1-4.055-7.012,4.087,4.087,0,0,1,5.558-3.449,6.511,6.511,0,0,1,3.431,2.929c1.6,2.763,1.078,6.064-1.16,7.358a3.954,3.954,0,0,1-2,.528m-4.1-3.692a5.526,5.526,0,0,0,2.686,2.41,3.293,3.293,0,0,0,2.906-.11c1.761-1.019,2.118-3.708.8-5.995a5.5,5.5,0,0,0-2.888-2.484,3.25,3.25,0,0,0-2.7.184,3.293,3.293,0,0,0-1.545,2.464,5.527,5.527,0,0,0,.749,3.53",
    transform: "translate(-201.597 -145.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_351",
    "data-name": "Trac\\xE9 351",
    d: "M5.18,341.681a4.058,4.058,0,0,1-.859-.094,5.524,5.524,0,0,1-2.954-1.876A5.418,5.418,0,0,1,0,336.383a3.7,3.7,0,0,1,1.225-3,.5.5,0,0,1,.653.754A2.727,2.727,0,0,0,1,336.35a4.419,4.419,0,0,0,1.121,2.709c1.466,1.693,3.352,2.1,4.8,1.029a.5.5,0,1,1,.592.8,3.9,3.9,0,0,1-2.336.791",
    transform: "translate(0 -314.784)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_352",
    "data-name": "Trac\\xE9 352",
    d: "M20.6,329.675a.5.5,0,0,1-.3-.9l.272-.2a.5.5,0,1,1,.594.8l-.272.2a.5.5,0,0,1-.3.1",
    transform: "translate(-18.985 -310.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_353",
    "data-name": "Trac\\xE9 353",
    d: "M25.5,179.67a.5.5,0,0,1-.3-.9l11.725-8.793a.5.5,0,0,1,.6.8L25.8,179.571a.5.5,0,0,1-.3.1",
    transform: "translate(-23.613 -160.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_354",
    "data-name": "Trac\\xE9 354",
    d: "M108.932,458.613a.5.5,0,0,1-.256-.928l.4-.24a.5.5,0,0,1,.511.857l-.4.24a.5.5,0,0,1-.255.07",
    transform: "translate(-102.42 -432.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_355",
    "data-name": "Trac\\xE9 355",
    d: "M116.211,426a.5.5,0,0,1-.249-.932l3.307-1.9a.5.5,0,1,1,.5.865l-3.307,1.9a.5.5,0,0,1-.248.066",
    transform: "translate(-109.296 -399.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_356",
    "data-name": "Trac\\xE9 356",
    d: "M320.729,326.066a.5.5,0,0,1-.249-.932l1.511-.868a.5.5,0,0,1,.5.865l-1.511.868a.5.5,0,0,1-.248.066",
    transform: "translate(-302.475 -306.225)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Chlorit",
    d: "M3.428,8.224q-.851,0-1.441-.3t-.9-.851Q.775,6.522.738,5.744.729,5.369.729,4.939t.009-.823q.037-.768.352-1.327T2,1.934q.59-.3,1.432-.3.622,0,1.116.165t.842.453q.348.288.54.672t.2.833q.009.082-.05.137t-.142.055H5.065q-.1,0-.165-.05t-.091-.169q-.146-.6-.5-.823t-.887-.22q-.613,0-.979.343t-.393,1.13q-.027.75,0,1.537t.393,1.13q.366.343.979.343.531,0,.887-.224t.5-.819Q4.837,6,4.9,5.955t.165-.046h.869q.082,0,.142.055t.05.137q-.009.448-.2.833t-.54.672q-.348.288-.842.453T3.428,8.224Zm3.906-.091a.236.236,0,0,1-.044,0A.205.205,0,0,1,7.212,8.1a.231.231,0,0,1-.034-.028Q7.115,8,7.115,7.913V1.856q0-.091.064-.156t.156-.064h.814q.1,0,.16.064t.059.156V3.942q.247-.293.6-.476t.878-.183q.558,0,.974.252t.645.709q.229.457.229,1.1V7.913q0,.091-.064.156A.231.231,0,0,1,11.6,8.1a.205.205,0,0,1-.078.032.236.236,0,0,1-.044,0h-.823a.236.236,0,0,1-.044,0,.205.205,0,0,1-.078-.032.231.231,0,0,1-.034-.028q-.064-.064-.064-.156V5.4q0-.531-.261-.833t-.755-.3q-.476,0-.764.3T8.368,5.4V7.913q0,.091-.059.156a.2.2,0,0,1-.032.028.191.191,0,0,1-.037.02.216.216,0,0,1-.043.012.273.273,0,0,1-.048,0Zm5.755,0a.236.236,0,0,1-.044,0,.205.205,0,0,1-.078-.032.231.231,0,0,1-.034-.028q-.064-.064-.064-.156V1.856q0-.091.064-.156t.156-.064h.759q.091,0,.156.064t.064.156V7.913q0,.091-.064.156a.231.231,0,0,1-.034.028.205.205,0,0,1-.078.032.236.236,0,0,1-.044,0Zm4.3.091q-.732,0-1.23-.256T15.4,7.245q-.261-.467-.3-1.089-.009-.165-.009-.4t.009-.4q.037-.631.306-1.093t.768-.718q.5-.256,1.212-.256T18.6,3.54q.5.256.768.718t.306,1.093q.009.165.009.4t-.009.4q-.037.622-.3,1.089t-.759.723Q18.12,8.224,17.389,8.224Zm0-.906q.485,0,.75-.306t.293-.9q.009-.137.009-.357T18.431,5.4q-.027-.586-.293-.9t-.75-.311q-.485,0-.75.311t-.293.9q-.009.137-.009.357t.009.357q.027.595.293.9T17.389,7.318Zm3.531.814a.236.236,0,0,1-.044,0A.205.205,0,0,1,20.8,8.1a.231.231,0,0,1-.034-.028Q20.7,8,20.7,7.913V3.6q0-.1.064-.165t.156-.064h.741q.091,0,.16.064t.069.165v.375q.21-.293.544-.448t.773-.156h.375q.1,0,.16.064t.059.156v.659q0,.091-.059.156t-.16.064h-.714q-.439,0-.682.247t-.242.677V7.913q0,.091-.064.156a.216.216,0,0,1-.034.028.208.208,0,0,1-.039.02.228.228,0,0,1-.043.012.278.278,0,0,1-.048,0Zm3.815,0a.236.236,0,0,1-.044,0,.205.205,0,0,1-.078-.032.231.231,0,0,1-.034-.028q-.064-.064-.064-.156V3.594q0-.091.064-.156t.156-.064h.759q.1,0,.16.064t.059.156V7.913q0,.091-.059.156a.2.2,0,0,1-.032.028.191.191,0,0,1-.037.02.216.216,0,0,1-.043.012.273.273,0,0,1-.048,0ZM24.7,2.588q-.1,0-.16-.059t-.059-.16V1.71q0-.091.059-.156t.16-.064h.833q.1,0,.165.064t.064.156v.659q0,.1-.064.16t-.165.059Zm4.382,5.544q-.549,0-.924-.192T27.6,7.368q-.183-.38-.183-.947V4.345h-.723q-.091,0-.156-.064t-.064-.156V3.594q0-.091.064-.156t.156-.064h.723V1.856q0-.091.059-.156t.16-.064h.741q.091,0,.156.064t.064.156V3.375h1.144q.091,0,.156.064t.064.156v.531q0,.091-.064.156t-.156.064H28.6V6.33q0,.375.133.586t.462.21h.631q.091,0,.156.064t.064.156v.567q0,.091-.064.156a.231.231,0,0,1-.034.028.205.205,0,0,1-.078.032.236.236,0,0,1-.044,0Z",
    transform: "translate(25.464 2751.797)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChlorit);
export default __webpack_public_path__ + "static/media/CHLORIT.3dff7ce7f1cbfd97f2e326c7d5b98fc1.svg";
export { ForwardRef as ReactComponent };